import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/giftGuide';

export const GIFT_GUIDE_HEADLINE_GET_SUCCESS = `${rootActionPath}/headline/GET_${SUCCESS_SUFFIX}`;
export const GIFT_GUIDE_HEADLINE_GET_FAILURE = `${rootActionPath}/headline/GET_${FAILURE_SUFFIX}`;
export const GIFT_GUIDE_FEATURED_DEALS_GET_SUCCESS = `${rootActionPath}/featuredDeals/GET_${SUCCESS_SUFFIX}`;
export const GIFT_GUIDE_FEATURED_DEALS_GET_FAILURE = `${rootActionPath}/featuredDeals/GET_${FAILURE_SUFFIX}`;

export const GIFT_GUIDE_VIEW = `${rootActionPath}/VIEW`;
